import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

export interface IMapExtendedViewToggleControlProps {
  isExtendedView: boolean;
  onToggle: () => void;
}

/**
 * Pulsante nei controlli mappa che apre/chiude la visualizzazione estesa.
 * Vive nel viewport OpenLayers, quindi è disponibile sia inline sia nella Modal.
 */
export function MapExtendedViewToggleControl(
  props: IMapExtendedViewToggleControlProps,
) {
  const { isExtendedView, onToggle } = props;
  const { t } = useTranslation();

  const label = isExtendedView
    ? t('map-widget.extended-view.close', 'Riduci mappa')
    : t('map-widget.extended-view.open', 'Visualizzazione estesa');

  return (
    <div>
      <Tooltip title={label}>
        <Button
          type="default"
          style={{ borderWidth: '1px' }}
          aria-label={label}
          icon={
            isExtendedView ? <FullscreenExitOutlined /> : <FullscreenOutlined />
          }
          onClick={onToggle}
        />
      </Tooltip>
    </div>
  );
}
